<template>
    <div class="">
        <v-row>
            <v-col cols="12" lg="8">
                <v-row>
                    <v-col cols="12">
                        <div class="bg-white rounded-lg shadow p-5">
                            <div class="flex items-center justify-between">
                                <div class="flex items-center">
                                    <span
                                        class="w-8 h-8 rounded-lg text-blue-500 flex grow-0 items-center justify-center bg-blue-100">
                                        <v-icon style="color: inherit;" size="19">mdi-cash</v-icon>
                                    </span>
                                    <h1 class="font-bold text-stone-600 mr-2">گردش حساب</h1>
                                </div>
                                <router-link to="/turnOver">
                                    <span class="text-[10px] text-blue-400">بیشتر</span>
                                </router-link>
                            </div>
                            <div class="mt-3">
                                <span class="text-xs text-stone-400">نمودار گردش حساب شما</span>
                            </div>
                            <div class="chartBox mt-5">
                                <apexchart v-if="dataDashboard.turnOverChart[0]" height="360" :options="options" :series="series"></apexchart>
                                <div v-else-if="loading" class="flex justify-center p-10 bg-slate-50 text-sm text-stone-400">
                                    <v-progress-circular color="primary" indeterminate />
                                </div>
                                <div v-else class="text-center p-10 bg-slate-50 text-sm text-stone-400">
                                    اطلاعاتی موجود نیست
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" lg="4">
                <v-row>
                    <v-col cols="6">
                        <div class="p-5 rounded-lg shadow bg-white">
                            <div class="flex items-center justify-between">
                                <span
                                    class="w-8 h-8 rounded-lg text-green-500 flex grow-0 items-center justify-center bg-green-100">
                                    <v-icon style="color: inherit;" size="19">mdi-note-multiple-outline</v-icon>
                                </span>
                                <router-link to="/orders">
                                    <span class="text-[10px] text-blue-400">بیشتر</span>
                                </router-link>
                            </div>
                            <h1 class="text-stone-600 mt-1 text-sm">اعلام بار فعال</h1>
                            <span class="block font-bold text-stone-500 mt-2 text-xl">{{ dataDashboard.orderCount }}</span>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <div class="p-5 rounded-lg shadow bg-white">
                            <div class="flex items-center justify-between">
                                <span
                                    class="w-8 h-8 rounded-lg text-violet-500 flex grow-0 items-center justify-center bg-violet-100">
                                    <v-icon style="color: inherit;" size="20">mdi-truck-outline</v-icon>
                                </span>
                                <router-link to="/remittance">
                                    <span class="text-[10px] text-blue-400">بیشتر</span>
                                </router-link>
                            </div>
                            <h1 class="text-stone-600 mt-1 text-sm">حواله‌های جاری</h1>
                            <span class="block font-bold text-stone-500 mt-2 text-xl">{{ dataDashboard.remittanceCount }}</span>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <div class="p-5 rounded-lg shadow bg-white">
                            <div class="flex items-center justify-between">
                                <span
                                    class="w-8 h-8 rounded-lg text-yellow-500 flex grow-0 items-center justify-center bg-yellow-100">
                                    <v-icon style="color: inherit;" size="19">mdi-text-box-multiple-outline</v-icon>
                                </span>
                                <router-link to="/remittanceHistory">
                                    <span class="text-[10px] text-blue-400">بیشتر</span>
                                </router-link>
                            </div>
                            <h1 class="text-stone-600 mt-1 text-sm">بارهای حمل شده</h1>
                            <span class="block font-bold text-stone-500 mt-2 text-xl">{{ dataDashboard.remittanceHistoryCount }}</span>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <div class="p-5 rounded-lg shadow bg-white">
                            <div class="flex items-center justify-between">
                                <span
                                    class="w-8 h-8 rounded-lg text-red-500 flex grow-0 items-center justify-center bg-red-100">
                                    <v-icon style="color: inherit;">mdi-account-group-outline</v-icon>
                                </span>
                                <router-link to="/tickets">
                                    <span class="text-[10px] text-blue-400">بیشتر</span>
                                </router-link>
                            </div>
                            <h1 class="text-stone-600 mt-1 text-sm">تیکت های فعال</h1>
                            <span class="block font-bold text-stone-500 mt-2 text-xl">{{ dataDashboard.ticketCount }}</span>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="p-5 rounded-lg shadow bg-white">
                            <div class="flex items-center justify-between">
                                <div class="flex items-center">
                                    <span
                                        class="w-8 h-8 rounded-lg text-orange-500 flex grow-0 items-center justify-center bg-orange-100">
                                        <v-icon style="color: inherit;">mdi-cash</v-icon>
                                    </span>
                                    <h1 class="text-stone-600 mt-1 text-sm mr-2">تراکنش های اخیر</h1>
                                </div>
                                <router-link to="/turnOver">
                                    <span class="text-[10px] text-blue-400">بیشتر</span>
                                </router-link>
                            </div>
                            <div class="mt-5 space-y-4">
                                <div class="flex items-center" v-for="turn in dataDashboard.lastTurnOver" :key="turn.id">
                                    <span
                                        class="w-2 h-2 rounded-full flex grow-0 shrink-0 items-center justify-center bg-orange-200">
                                    </span>
                                    <span class="mr-2 text-[10px]">{{ translate(turn.type) }}</span>
                                    <div class="mr-auto text-[10px]" :class="colorPrice(turn.previous_inventory, turn.inventory)">
                                        {{ `${decreaseOrAddPrice(turn.previous_inventory, turn.inventory)} ${separate(turn.amount)} ریال` }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axiosApi from "@/plugins/axios";
import {convertDateOnly} from "@/plugins/getPersianDate";
import Separate from "@/plugins/separate";

export default {
    name: 'dashboard',
    data() {
        return {
            routeRole: null,
            role: null,
            loading: false,

            series: [{
                name: 'گردش',
                data: []
            }],
            options: {},
            dataDashboard: {
                orderCount: 0,
                ticketCount: 0,
                remittanceCount: 0,
                remittanceHistoryCount: 0,
                turnOverChart: [],
                lastTurnOver: [],
            },
            
        }
    },
    methods: {
        decreaseOrAddPrice(prevPrice, nowPrice){
            return parseInt(nowPrice) < parseInt(prevPrice) ? '-' : '+'
        },
        colorPrice(prevPrice, nowPrice){
            return parseInt(nowPrice) < parseInt(prevPrice) ? 'text-red-500' : 'text-green-500'
        },
        separate(v){
            return Separate(v)
        },
        getFactory(){
            this.loading = true
            axiosApi().get(`v2/${this.routeRole}/dashboard/site`)
            .then((result) => {
                this.dataDashboard.orderCount = result.data.data.orderCount
                this.dataDashboard.remittanceCount = result.data.data.remittanceCount
                this.dataDashboard.turnOverChart = result.data.data.date_TurnOver
                this.dataDashboard.ticketCount = result.data.data.ticketCount
                this.dataDashboard.lastTurnOver = result.data.data.turnOver
                this.dataDashboard.remittanceHistoryCount = result.data.data.remittanceHistoryCount
                this.setChartData(this.dataDashboard.turnOverChart)
            })
            .catch(e => {
              this.errors = e.response.data.errors
            })
            .finally(() => this.loading = false)
        },
        setChartData(data){
            if (data) {
                const seriesChart = data.map(turn => {
                    let split = turn.amount.split('.')[0]
                    const obj = {
                        x: convertDateOnly(turn.created_at),
                        y: +split,
                    }
                    return obj
                })
                this.options = {
                    chart: {
                        type: "area",
                        background: '#f8fafc',
                        fontFamily: 'iranYekanBold, sans-serif',
                        foreColor: '#a8a29e',
                        zoom: {
                            autoScaleYaxis: true,
                            enabled: true,
                            type: 'x',
                        },
                        toolbar: {
                           autoSelected: "pan",
                            show: true,
                            tools: {
                                download: false,
                                selection: true,
                                zoom: false,
                                zoomin: true,
                                zoomout: true,
                                pan: true,
                                reset: true | '<img src="/static/icons/reset.png" width="20">',
                            },
                        },
                    },
                    dataLabels: {
                      enabled: false
                    },
                    fill: {
                        gradient: {
                            enabled: true,
                            opacityFrom: 0.55,
                            opacityTo: 0
                        }
                    },
                    xaxis: {
                        labels: {
                            rotate: -0,
                        },
                        tickAmount: 4,
                        max: data.length,
                        min: data.length - 10,
                        floating: true,
                        // tickPlacement: 'on',
                        categories: [],
                    },
                    yaxis: {
                        type: 'datetime',
                        labels: {
                            formatter: function (value) {
                               return `${Separate(Math.round(value))} ریال`;
                            },
                        },
                        // opposite: true
                        floating: true,
                        min: 0,
                        tickAmount: 5
                    },
                    stroke: {
                        width: '3',
                        curve: 'smooth',
                    },
                    markers: {
                        size: 5,
                        colors: ["#fff"],
                        strokeColor: "#00BAEC",
                        strokeWidth: 3
                    },
                    grid: {
                        yaxis: {
                            lines: {
                                show: false
                            }
                        },
                        padding: {
                            left: 30,
                            bottom: 30
                        },
                        borderColor: '#ececec',
                    },
                },                
                seriesChart.forEach(i => {
                    this.series[0].data.push(i.y)
                    this.options.xaxis.categories.push(i.x)
                })
            }
        },
        getRole(){
            this.role = localStorage.getItem('role')
            this.role === 'COMPANY' || this.role === 'COMPANY_MEMBER'? this.routeRole = 'company' : this.routeRole = 'factory'
        },
    },
    mounted(){
        this.getRole()
        this.role !== 'ADMIN' ?  this.getFactory() : ''
    }
}
</script>

<style>
.apexcharts-text tspan, .apexcharts-tooltip-text-y-label {
    font-family: iranYekanBold, sans-serif !important;
    font-size: 9px;
}
</style>